import AreasVertical from "../../components/areasVertical";
import BannerSubhome from "../../components/bannerSubhome";
import Clientes from "../../components/clientes";
import Contato from "../../components/contato";
import Depoimentos from "../../components/depoimentos";
import LinksVertical from "../../components/linksVertical";
import MarcaVertical from "../../components/marcaVertical";
import Marcas from "../../components/marcas";
import Rodape from "../../components/rodape";
import Video from "../../components/video";

function Projects() {
    return (
        <>
            <Contato />
            <BannerSubhome
                image="banner_projects.png"
                title="PROJECTS"
                subtitle={
                    <>
                        <strong>TRANSFORMAÇÕES</strong> REAIS, PROJETOS{" "}
                        <strong>EFETIVOS</strong>.
                    </>
                }
                marca={{
                    color: "#9B06CC",
                    logoSrc: "../assets/behub_logo.svg",
                }}
                hoveredBrand="behub"
                brands={[{ id: "behub" }]}
            />
            <AreasVertical
                slides={[
                    {
                        id: "development",
                        title: "Development",
                        text: (
                            <>
                                Alavancamos negócios focados na eficiência de
                                aplicativos,{" "}
                                <span className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent font-bold">
                                    sistemas e plataformas que geram resultados
                                    efetivos
                                </span>{" "}
                                e impactantes.
                            </>
                        ),
                    },
                    {
                        id: "business-agility",
                        title: "Business Agility",
                        text: (
                            <>
                                Lideramos a implementação de{" "}
                                <span className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] bg-clip-text text-transparent font-bold">
                                    metodologias e soluções ágeis personalizadas
                                </span>
                                , criadas para superar as expectativas
                                específicas de cada{" "}
                                <span className="font-bold">projeto</span>.
                            </>
                        ),
                    },
                ]}
            />
            <MarcaVertical
                logoSrc="../assets/behub_logo.svg"
                backgroundImage="../assets/behub_background.png"
                buttonBgGradient="from-[#A800E4] to-[#FF1B76]"
                infoText={
                    <>
                        Lideramos a<br />
                        implementação de
                        <br />
                        metodologias e soluções
                        <br />
                        ágeis personalizadas,
                        <br />
                        <span className="font-bold">
                            conectando inovação e<br />
                            melhoria contínua em
                            <br />
                            projetos
                        </span>
                        .
                    </>
                }
            />
            <LinksVertical
                areasData={[
                    {
                        icon: "../assets/servicos/development_icon.png",
                        iconHover: "../assets/servicos/development_icon.png",
                        title: "Development",
                        text: (
                            <>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/desenvolvimento-de-solucoes"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Desenvolvimento de Soluções
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/desenvolvimento-de-softwares"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Desenvolvimento de Softwares
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/recuperacao-de-projetos"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Recuperação de Projetos
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/programa-new-techs"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Programa New Techs
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/development#modeloEntrega"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Modelos de Entrega
                                    </a>
                                </div>
                            </>
                        ),
                        glowColor: "#A002CB",
                        url: "/development",
                    },
                    {
                        icon: "../assets/servicos/business_icon.png",
                        iconHover: "../assets/servicos/business_icon.png",
                        title: "Business Agility",
                        text: (
                            <>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/ato"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        ATO
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/pmo"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        PMO
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/gestao-de-mudancas"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Gestão de Mudanças
                                    </a>
                                </div>
                                <div className="flex items-center mb-2">
                                    <img
                                        src="/assets/arrow.svg"
                                        alt="arrow"
                                        className="w-6 h-6 mr-2"
                                    />
                                    <a
                                        href="/gestao-de-portfolio"
                                        className="text-white font-inter-regular cursor-pointer hover:underline"
                                    >
                                        Gestão de Portfolio
                                    </a>
                                </div>
                            </>
                        ),
                        glowColor: "#A002CB",
                        url: "/business-agility",
                    },
                ]}
            />
            <Video />
            <Marcas />
            <Clientes />
            <Depoimentos />
            <Rodape />
        </>
    );
}

export default Projects;
